"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveRootLevelLeavesAtTop = exports.getDomainTypeLabel = exports.isChildTypeDomain = exports.defaultDirectoryHasChildren = exports.shouldNodeBeHighlighted = exports.shouldDisableDefaultDirectory = exports.getValuesFromTheSelectedNodes = exports.isDefaultDirectorySelected = exports.getTree = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _app = require("utils/app");

var _checkCircle = _interopRequireDefault(require("../../assets/check-circle.svg"));

var _checkYellow = _interopRequireDefault(require("../../assets/check-yellow.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getTree = function getTree(environmentGroups, environments) {
  var checkedNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var initialCheckedNodes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var applicationRoot = arguments.length > 4 ? arguments[4] : undefined;
  var defaultDirectory = arguments.length > 5 ? arguments[5] : undefined;
  var environmentData = arguments.length > 6 ? arguments[6] : undefined;
  var allowedScopes = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var isTouched = arguments.length > 8 ? arguments[8] : undefined;
  var rightIconConfig = arguments.length > 9 ? arguments[9] : undefined;
  var outOfSyncEnvironments = arguments.length > 10 ? arguments[10] : undefined;

  if (!applicationRoot.id) {
    return {};
  }

  var clonedEnvironmentGroups = _objectSpread({}, environmentGroups);

  var newAppRoot = applicationRoot.id;
  var defaultDirData = clonedEnvironmentGroups[defaultDirectory];

  if (!(0, _isEmpty.default)(defaultDirData)) {
    if (!defaultDirectoryHasChildren(environmentGroups, defaultDirectory)) {
      return {};
    } // Check and remove the default directory from the environment group.
    // And find the child of the default directory to be used as the tree root.


    newAppRoot = defaultDirData.childGroupIds[0];
    delete clonedEnvironmentGroups[defaultDirectory];
  } else if (applicationRoot.name) {
    // Change the root node name if the default directory is not present.
    clonedEnvironmentGroups[newAppRoot].name = applicationRoot.name;
  }

  clonedEnvironmentGroups[newAppRoot].icon = applicationRoot.appIcon;
  var createdTree = createTree(newAppRoot, clonedEnvironmentGroups, environments, checkedNodes, initialCheckedNodes, environmentData, allowedScopes, isTouched, rightIconConfig, outOfSyncEnvironments);
  return createdTree;
};

exports.getTree = getTree;

var createTree = function createTree(nodeId, environmentGroups, environments, checkedNodes, initialCheckedNodes, environmentData, allowedScopes, isTouched, rightIconConfig, outOfSyncEnvironments) {
  var _environmentGroups$no5, _environmentGroups$no6, _environmentGroups$no7;

  var childNodes = [];
  var childGroupNodes = [];
  var childEnvironmentNodes = [];
  var isNodeHighlighted = shouldNodeBeHighlighted(isTouched, checkedNodes, initialCheckedNodes, nodeId);

  if (environmentGroups[nodeId]) {
    var _environmentGroups$no, _environmentGroups$no2, _environmentGroups$no3, _environmentGroups$no4;

    if ((_environmentGroups$no = environmentGroups[nodeId]) !== null && _environmentGroups$no !== void 0 && (_environmentGroups$no2 = _environmentGroups$no.childGroupIds) !== null && _environmentGroups$no2 !== void 0 && _environmentGroups$no2.length) {
      childGroupNodes = environmentGroups[nodeId].childGroupIds.map(function (childId) {
        var children = createTree(childId, environmentGroups, environments, checkedNodes, initialCheckedNodes, environmentData, [].concat(_toConsumableArray(allowedScopes), _toConsumableArray(allowedScopes.includes(nodeId) ? [childId] : [])), isTouched, rightIconConfig, outOfSyncEnvironments);
        return children;
      });
    }

    if ((_environmentGroups$no3 = environmentGroups[nodeId]) !== null && _environmentGroups$no3 !== void 0 && (_environmentGroups$no4 = _environmentGroups$no3.childEnvironmentIds) !== null && _environmentGroups$no4 !== void 0 && _environmentGroups$no4.length) {
      childEnvironmentNodes = environmentGroups[nodeId].childEnvironmentIds.map(function (childId) {
        var _currentChild$created;

        var currentChild = environments[childId];
        return _objectSpread({
          label: isChildTypeDomain(currentChild) ? getDomainTypeLabel(currentChild) : (0, _get.default)(environmentData, "".concat([childId], ".catalogAppDisplayName")) || (0, _get.default)(currentChild, 'name', ''),
          value: currentChild.id,
          checked: checkedNodes.includes(currentChild.id),
          highlighted: shouldNodeBeHighlighted(isTouched, checkedNodes, initialCheckedNodes, currentChild.id),
          type: 'leaf',
          disabled: allowedScopes.length ? !(allowedScopes.includes(currentChild.id) || allowedScopes.includes(currentChild.parentGroupId)) : false,
          createdDate: currentChild === null || currentChild === void 0 ? void 0 : (_currentChild$created = currentChild.created) === null || _currentChild$created === void 0 ? void 0 : _currentChild$created.date
        }, getIntegratedIcons(childId, environmentData, currentChild.status, rightIconConfig, outOfSyncEnvironments));
      });
    }

    childNodes.push.apply(childNodes, _toConsumableArray(childGroupNodes).concat(_toConsumableArray(childEnvironmentNodes)));
  }

  return {
    label: environmentGroups[nodeId].name,
    value: environmentGroups[nodeId].id,
    expanded: true,
    checked: checkedNodes.includes(environmentGroups[nodeId].id),
    highlighted: isNodeHighlighted,
    type: 'node',
    nodes: childNodes,
    leftIcon: {
      icon: (_environmentGroups$no5 = environmentGroups[nodeId]) === null || _environmentGroups$no5 === void 0 ? void 0 : _environmentGroups$no5.icon
    },
    createdDate: (_environmentGroups$no6 = environmentGroups[nodeId]) === null || _environmentGroups$no6 === void 0 ? void 0 : (_environmentGroups$no7 = _environmentGroups$no6.created) === null || _environmentGroups$no7 === void 0 ? void 0 : _environmentGroups$no7.date,
    disabled: allowedScopes.length ? !(allowedScopes.includes(environmentGroups[nodeId].id) || allowedScopes.includes(environmentGroups[nodeId].parentId)) : false
  };
};

var getIntegratedIcons = function getIntegratedIcons(id) {
  var environmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var status = arguments.length > 2 ? arguments[2] : undefined;
  var rightIconConfig = arguments.length > 3 ? arguments[3] : undefined;
  var outOfSyncEnvironments = arguments.length > 4 ? arguments[4] : undefined;

  if (environmentData[id]) {
    var _env$catalogApplicati;

    var env = environmentData[id];
    var isEnvScanned = env.envScanStatus;
    var isHierarchical = (_env$catalogApplicati = env.catalogApplication) === null || _env$catalogApplicati === void 0 ? void 0 : _env$catalogApplicati.requiresHierarchicalModel;
    var isEnvActive = status === 'active';

    if (!(0, _isEmpty.default)(outOfSyncEnvironments) && outOfSyncEnvironments !== null && outOfSyncEnvironments !== void 0 && outOfSyncEnvironments.includes(env.environmentId)) {
      return {
        rightIcon: {
          icon: _checkYellow.default,
          tooltip: 'Permission mismatch',
          onClick: function onClick() {
            return rightIconConfig.onClick(env.environmentId);
          }
        }
      };
    }

    if (rightIconConfig) {
      if (env[rightIconConfig.property]) {
        return {
          rightIcon: {
            icon: _checkCircle.default,
            tooltip: rightIconConfig.tooltip
          }
        };
      }

      return {};
    }

    if (!isHierarchical && isEnvScanned && isEnvActive) {
      return {
        rightIcon: {
          icon: _checkCircle.default,
          tooltip: 'Integrated'
        }
      };
    }

    return {};
  }

  return {};
};

var isDefaultDirectorySelected = function isDefaultDirectorySelected() {
  var checkedNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultDirectory = arguments.length > 1 ? arguments[1] : undefined;
  return checkedNodes.includes(defaultDirectory);
};

exports.isDefaultDirectorySelected = isDefaultDirectorySelected;

var getValuesFromTheSelectedNodes = function getValuesFromTheSelectedNodes() {
  var checkedNodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return checkedNodes.map(function (node) {
    return node.value;
  });
};

exports.getValuesFromTheSelectedNodes = getValuesFromTheSelectedNodes;

var shouldDisableDefaultDirectory = function shouldDisableDefaultDirectory(disabled) {
  var checkedNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultDirectory = arguments.length > 2 ? arguments[2] : undefined;
  var allowedScopes = arguments.length > 3 ? arguments[3] : undefined;

  if (disabled) {
    return true;
  }

  if (allowedScopes.length) {
    return allowedScopes[0] !== defaultDirectory;
  }

  if (isDefaultDirectorySelected(checkedNodes, defaultDirectory)) {
    return false;
  }

  if (!checkedNodes.length) {
    return false;
  }

  return true;
};

exports.shouldDisableDefaultDirectory = shouldDisableDefaultDirectory;

var shouldNodeBeHighlighted = function shouldNodeBeHighlighted(isTouched, checkedNodes, initialCheckedNodes, nodeId) {
  if (!isTouched) {
    return false;
  }

  return initialCheckedNodes.includes(nodeId) !== checkedNodes.includes(nodeId);
};

exports.shouldNodeBeHighlighted = shouldNodeBeHighlighted;

var defaultDirectoryHasChildren = function defaultDirectoryHasChildren(environmentGroups, defaultDirectory) {
  var _defaultDirData$child;

  var defaultDirData = environmentGroups[defaultDirectory];

  if ((0, _isEmpty.default)(defaultDirData)) {
    return false;
  }

  if ((_defaultDirData$child = defaultDirData.childGroupIds) !== null && _defaultDirData$child !== void 0 && _defaultDirData$child.length) {
    return true;
  }

  return false;
};

exports.defaultDirectoryHasChildren = defaultDirectoryHasChildren;

var isChildTypeDomain = function isChildTypeDomain() {
  var child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _get.default)(child, 'type', '') === 'DOMAIN';
};

exports.isChildTypeDomain = isChildTypeDomain;

var getDomainTypeLabel = function getDomainTypeLabel() {
  var child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "(Domain) ".concat((0, _get.default)(child, 'name', ''));
};

exports.getDomainTypeLabel = getDomainTypeLabel;

var moveRootLevelLeavesAtTop = function moveRootLevelLeavesAtTop(appName) {
  return (0, _app.isOCI)(appName);
};

exports.moveRootLevelLeavesAtTop = moveRootLevelLeavesAtTop;